import instance from "./axios.base";

const getEmpRaisesAndDeductions = async () => {
  const res = await instance.get("/addanddedution");
  return res.data;
};

export { getEmpRaisesAndDeductions };
